//src/components/Fields/constants/fieldTypes.js

/**
 * Canonical strings that identify field classes.
 * Any layer (builder, runtime, backend) should import from here.
 */
export const FIELD_TYPE_CALCULATED = 'calculated';

// future home for others:
// export const FIELD_TYPE_TEXT  = 'text';
// export const FIELD_TYPE_IMAGE = 'image';
